import React from 'react';
import { Empty as AntEmpty } from 'antd';

/**
 * Wrapper component for Ant Design Empty
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Empty functionality including image, description, and custom content.
 * 
 * @component
 * @example
 * import { Empty } from '../GeneralComponents/ui';
 * 
 * <Empty description="No Data" />
 * <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
 * <Empty>
 *   <Button type="primary">Create Now</Button>
 * </Empty>
 * 
 * @see https://ant.design/components/empty/ - Ant Design Empty documentation
 */
const Empty = (props) => {
  return <AntEmpty {...props} />;
};

export default Empty;

